import React from "react";
import { Navigate } from "react-router-dom";

interface AdminRouteProps {
  component: React.ComponentType<any>;
  component_m?: React.ComponentType<any>;
}

const AdminRoute: React.FC<AdminRouteProps> = ({
  component: Component,
  component_m: Component_Mobile,
}) => {
  const isMaster = localStorage.getItem("authority") === "ok";
  const ismobile = /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return isMaster && ismobile && Component_Mobile ? (
    <Component_Mobile />
  ) : isMaster && ismobile ? (
    <Navigate to="/admin/livelist" replace />
  ) : isMaster ? (
    <Component />
  ) : (
    <Navigate to="/admin/login" replace />
  );
};

export default AdminRoute;
